module.exports = __webpack_public_path__ + "img/stock0.e4bbc8fa.png";